<template>
  <section class="w-100">
    <div
      :id="`maintenance-${target}-${index}`"
      v-b-toggle="`collapse-maintenance-${target}-${index}`"
      data-cy="btn-device-maintenance-toggle"
      class="col mb-0">
      <h6 class="d-inline-block font-weight-bold cursor-pointer width-only-content hover mt-3">
        {{ $t('message.onBoarding.devices.maintenance.title') }}
      </h6>
    </div>
    <div class="col-12 px-0">
      <b-collapse
        :id="`collapse-maintenance-${target}-${index}`"
        :visible="false"
        class="col"
        @show="handleCollapseShow">
        <div class="row details-row-bg-1 py-01rem">
          <div class="col-sm-12 col-md-3">
            <!-- <coozzy-search-select
              v-if="!readOnly"
              id="contact"
              v-model="contact"
              :options="availableContacts"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              :preselect-first="false"
              :taggable="false"
              :with-empty-option="true"
              label="label"
              track-by="value">
              {{ $t('message.onBoarding.devices.maintenance.company') }}
            </coozzy-search-select> -->
            <template v-if="!readOnly">
              <label>{{ $t('message.onBoarding.devices.maintenance.company') }}</label>
              <contact-search-select
                v-model="contact"
                data-cy="input-device-maintenance-company"
                :filters="{ active: true, isEmployee: false, isOnlyInterestedParty: false }"
                :placeholder="''"
                :close-on-select="true"
                :clear-on-select="false"
                :preserve-search="true"
                :preselect-first="false"
                :taggable="false"
                track-by="objectID"
                label="name"
                from="maintenance"
                :with-address="true" />
            </template>
            <span
              v-else
              data-cy="device-maintenance-company-value"
              class="show-data">
              <label
                class="mb-0">
                {{ $t('message.onBoarding.devices.maintenance.company') }}
              </label>
              <template v-if="isContactObjectExist(contact)">
                -
              </template>
              <template v-else>
                <router-link
                  :key="contact.value"
                  :to="getContactDetailRoute(contact.value)">
                  {{ getContactObject(contact).name }}
                </router-link>
                <br>
                <address-text
                  :show-short-country="true"
                  :hide-if-empty="true"
                  :address="getContactObject(contact).address" />
              </template>
            </span>
          </div>
          <div class="col-sm-12 col-md-3">
            <coozzy-form-input
              v-model="contract"
              data-cy="input-device-maintenance-contract-number"
              :is-read-only="readOnly"
              :name="$t('message.onBoarding.devices.contractnumber')" />
          </div>
          <div class="col-sm-12 col-md-3">
            <coozzy-form-input
              v-model="dates.subscriptionStart"
              data-cy="input-device-maintenance-subscription-start"
              :is-read-only="readOnly"
              :filter="'formatDate'"
              type="date"
              :name="$t('message.onBoarding.devices.maintenance.subscriptionStart')"
              @blur="dateToObject()" />
          </div>
          <div class="col-sm-12 col-md-3">
            <coozzy-form-input
              v-model="dates.subscriptionEnd"
              data-cy="input-device-maintenance-subscription-end"
              :is-read-only="readOnly"
              :filter="'formatDate'"
              type="date"
              :name="$t('message.onBoarding.devices.maintenance.subscriptionEnd')"
              @blur="dateToObject()" />
          </div>
        </div>
        <div class="row details-row-bg-2 py-01rem">
          <div class="col-sm-12 col-md-3">
            <coozzy-form-input
              v-model="dates.lastMaintenance"
              data-cy="input-device-maintenance-last"
              :is-read-only="readOnly"
              :filter="'formatDate'"
              type="date"
              :name="$t('message.onBoarding.devices.maintenance.officialControl')"
              :state="$v.lastMaintenance.$dirty && $v.lastMaintenance.$error ? false : null"
              @blur="dateToObject()" />
          </div>
          <div class="col-sm-12 col-md-3">
            <label for="interval">{{ $t('message.onBoarding.devices.maintenance.costs.interval.title') }}</label>
            <coozzy-form-select
              v-if="!readOnly"
              id="interval"
              v-model="intervalMaintenance"
              data-cy="select-device-maintenance-interval">
              <option value="UNDEFINED_INTERVAL">
                -
              </option>
              <option value="MONTHLY">
                {{ $t('message.onBoarding.devices.maintenance.costs.interval.monthly') }}
              </option>
              <option value="BI_MONTHLY">
                {{ $t('message.onBoarding.devices.maintenance.costs.interval.bi_monthly') }}
              </option>
              <option value="QUARTERLY">
                {{ $t('message.onBoarding.devices.maintenance.costs.interval.quarterly') }}
              </option>
              <option value="TRIANNUAL">
                {{ $t('message.onBoarding.devices.maintenance.costs.interval.triannual') }}
              </option>
              <option value="HALF_YEARLY">
                {{ $t('message.onBoarding.devices.maintenance.costs.interval.half_yearly') }}
              </option>
              <option value="YEARLY">
                {{ $t('message.onBoarding.devices.maintenance.costs.interval.yearly') }}
              </option>
              <option value="TWO_YEARLY">
                {{ $t('message.onBoarding.devices.maintenance.costs.interval.two_yearly') }}
              </option>
              <option value="THREE_YEARLY">
                {{ $t('message.onBoarding.devices.maintenance.costs.interval.three_yearly') }}
              </option>
              <option value="FOUR_YEARLY">
                {{ $t('message.onBoarding.devices.maintenance.costs.interval.four_yearly') }}
              </option>
              <option value="FIVE_YEARLY">
                {{ $t('message.onBoarding.devices.maintenance.costs.interval.five_yearly') }}
              </option>
              <option value="TEN_YEARLY">
                {{ $t('message.onBoarding.devices.maintenance.costs.interval.ten_yearly') }}
              </option>
              <option value="TWENTY_YEARLY">
                {{ $t('message.onBoarding.devices.maintenance.costs.interval.twenty_yearly') }}
              </option>
              <option value="EVERY_6_YEARS">
                {{ $t('message.onBoarding.devices.maintenance.costs.interval.every_6_years') }}
              </option>
              <option value="EVERY_8_YEARS">
                {{ $t('message.onBoarding.devices.maintenance.costs.interval.every_8_years') }}
              </option>
              <option value="EVERY_15_YEARS">
                {{ $t('message.onBoarding.devices.maintenance.costs.interval.every_15_years') }}
              </option>
            </coozzy-form-select>
            <span
              v-else
              data-cy="device-maintenance-interval-value"
              class="show-data">
              {{ !intervalMaintenance || intervalMaintenance === 'UNDEFINED_INTERVAL' ? '-' : $t(`message.onBoarding.devices.maintenance.costs.interval.${intervalMaintenance.toLowerCase()}`) }}
            </span>
          </div>
          <div class="col-sm-12 col-md-3">
            <coozzy-form-input
              v-model="dates.nextMaintenance"
              data-cy="input-device-maintenance-next"
              :is-read-only="readOnly"
              :filter="'formatDate'"
              type="date"
              :name="$t('message.onBoarding.devices.maintenance.nextControl')"
              @blur="dateToObject()" />
          </div>
        </div>
        <div class="row">
          <device-maintenance-costs
            ref="device-maintenance-costs"
            :index="index"
            :target="target"
            :device="device"
            :read-only="readOnly"
            @device-update="deviceUpdated" />
        </div>
        <div class="row">
          <div class="col-12">
            <coozzy-form-textarea
              v-model="note"
              data-cy="textarea-device-maintenance-remark"
              :is-read-only="readOnly"
              :initial="note">
              {{ $t('message.generic.note') }}
            </coozzy-form-textarea>
          </div>
        </div>
      </b-collapse>
    </div>
  </section>
</template>

<script>

import CoozzyFormInput from '../../../framework/components/form/input/CoozzyFormInput'
import { onboarding } from '@/mixins/onboarding'
import DeviceMaintenanceCosts from './DeviceMaintenanceCosts'
import ContactApi from '@/misc/apis/ContactApi'
// import CoozzySearchSelect from '@/framework/components/form/select/CoozzySearchSelect'
import ContactSearchSelect from '@/framework/components/search/ContactSearchSelect.vue'
import { validation } from '@/mixins/validation'
import AddressText from '@/framework/components/misc/AddressText'
import { contact } from '@/mixins/contact'
import { dateUtils } from '@/mixins/dateUtils'
import CoozzyFormSelect from '@/framework/components/form/select/CoozzyFormSelect'
import CoozzyFormTextarea from '@/framework/components/form/textarea/CoozzyFormTextarea'

function notInFuture(value) {
  return !(value && new Date(this.objectToIsoDate(value)) >= new Date())
}
function lessThanEnding(value, vm) {
  if (!vm.subscriptionEnd || vm.subscriptionEnd <= 0) {
    return true
  }

  return new Date(this.objectToIsoDate(value)) <= new Date(this.objectToIsoDate(vm.subscriptionEnd))
}
export default {
  name: 'DeviceMaintenance',
  components: { CoozzyFormTextarea, CoozzyFormSelect, DeviceMaintenanceCosts, CoozzyFormInput, ContactSearchSelect, AddressText },
  mixins: [onboarding, validation, contact, dateUtils],
  props: {
    index: {
      type: Number,
      default: 0
    },
    target: {
      type: String,
      default: 'building'
    },
    device: {
      type: Object,
      default: null
    },
    contactsList: {
      type: Array,
      default() {
        return []
      }
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loadingFinished: false,
      dates: {
        lastMaintenance: null,
        nextMaintenance: null,
        subscriptionStart: null,
        subscriptionEnd: null,
        contacts: this.contactsList
      },
      usedContacts: [],
      initialized: false
    }
  },
  computed: {
    globalContact() {
      return this.usedContacts.concat(this.contactsList)
    },
    contract: {
      get() {
        return this.device.maintenance.contract
      },
      set(value) {
        const device = this.device
        device.maintenance.contract = value
        this.dispatchDeviceUpdate(device)
      }
    },
    lastMaintenance: {
      get() {
        return this.device.maintenance.lastMaintenance || null
      },
      set(value) {
        const device = this.device
        device.maintenance.lastMaintenance = value
        this.dispatchDeviceUpdate(device)
      }
    },
    nextMaintenance: {
      get() {
        return this.device.maintenance.nextMaintenance || null
      },
      set(value) {
        const device = this.device
        device.maintenance.nextMaintenance = value
        this.dispatchDeviceUpdate(device)
      }
    },
    contact: {
      get() {
        if (this.device.maintenance && this.device.maintenance.contact) {
          const contact = this.globalContact.find(x => x.id === this.device.maintenance.contact.userReference || x.objectID === this.device.maintenance.contact.userReference)
          if (contact) {
            return [contact]
          }
          return null
        }
        return null
      },
      set(value) {
        this.usedContacts = this.usedContacts.concat(value)
        this.usedContacts = [...this.removeDuplicatesContact(this.usedContacts)]
        const contact = value.length > 0 ? value[value.length - 1] : {}
        const device = this.device
        device.maintenance.contact = {
          userReference: contact.userReference || contact.id || contact.objectID || null,
          accountId: contact.accountId || contact.owner ? contact.owner.id : null
        }
        this.dispatchDeviceUpdate(device)
      }
    },
    subscriptionStart: {
      get() {
        return this.device.maintenance.subscriptionStart || null
      },
      set(value) {
        const device = this.device
        device.maintenance.subscriptionStart = value
        this.dispatchDeviceUpdate(device)
      }
    },
    subscriptionEnd: {
      get() {
        return this.device.maintenance.subscriptionEnd || null
      },
      set(value) {
        const device = this.device
        device.maintenance.subscriptionEnd = value
        this.dispatchDeviceUpdate(device)
      }
    },
    intervalMaintenance: {
      get() {
        return this.device.maintenance.costs.interval
      },
      set(value) {
        const device = this.device
        device.maintenance.costs.interval = value
        this.dispatchDeviceUpdate(device)
      }
    },
    note: {
      get() {
        return this.device.maintenance.note
      },
      set(value) {
        const newDevice = this.device
        newDevice.maintenance.note = value
        this.dispatchDeviceUpdate(newDevice)
      }
    }
  },
  watch: {
    intervalMaintenance: function (value) {
      if (this.lastMaintenance && value) {
        if (value === 'UNDEFINED_INTERVAL') {
          this.dates.nextMaintenance = null
          this.dateToObject()
        } else {
          this.dates.nextMaintenance = this.addDayToDate(this.dates.lastMaintenance, value)
          this.dateToObject()
        }
      }
    },
    'dates.lastMaintenance': function (value) {
      if (this.intervalMaintenance && this.intervalMaintenance !== 'UNDEFINED_INTERVAL' && value) {
        this.dates.nextMaintenance = this.addDayToDate(value, this.intervalMaintenance)
        this.dateToObject()
      }
    }

  },
  mounted() {
    this.getDatesFromObject()
    // Defer heavy initialization until collapse is opened
    this.$nextTick(() => {
      this.loadingFinished = true
    })
  },
  methods: {
    addDayToDate(startDate, interval) {
      const date = new Date(startDate)
      if (interval === 'YEARLY') {
        date.setFullYear(date.getFullYear() + 1)
      } else if (interval === 'MONTHLY') {
        date.setMonth(date.getMonth() + 1)
      } else if (interval === 'TRIANNUAL') {
        date.setMonth(date.getMonth() + 4)
      } else if (interval === 'QUARTERLY') {
        date.setMonth(date.getMonth() + 3)
      } else if (interval === 'HALF_YEARLY') {
        date.setMonth(date.getMonth() + 6)
      } else if (interval === 'BI_MONTHLY') {
        date.setMonth(date.getMonth() + 2)
      } else if (interval === 'TWO_YEARLY') {
        date.setFullYear(date.getFullYear() + 2)
      } else if (interval === 'THREE_YEARLY') {
        date.setFullYear(date.getFullYear() + 3)
      } else if (interval === 'FOUR_YEARLY') {
        date.setFullYear(date.getFullYear() + 4)
      } else if (interval === 'FIVE_YEARLY') {
        date.setFullYear(date.getFullYear() + 5)
      } else if (interval === 'TEN_YEARLY') {
        date.setFullYear(date.getFullYear() + 10)
      } else if (interval === 'TWENTY_YEARLY') {
        date.setFullYear(date.getFullYear() + 20)
      } else if (interval === 'EVERY_6_YEARS') {
        date.setFullYear(date.getFullYear() + 6)
      } else if (interval === 'EVERY_8_YEARS') {
        date.setFullYear(date.getFullYear() + 8)
      } else if (interval === 'EVERY_15_YEARS') {
        date.setFullYear(date.getFullYear() + 15)
      }
      return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`
    },
    dispatchDeviceUpdate(newDevice) {
      if (this.loadingFinished) {
        if (this.target === 'building') {
          this.$store.dispatch('onboarding/updateBuildingDevice', newDevice)
        } else {
          this.$store.dispatch('onboarding/updateObjectDevice', newDevice)
        }
        this.$emit('device-update', newDevice)
      }
    },
    deviceUpdated(newDevice) {
      this.$emit('device-update', newDevice)
    },
    parseDate(s) {
      const b = s.split(/\D/)
      return new Date(b[0], --b[1], b[2])
    },
    isContactObjectExist(contact) {
      return !contact || !this.globalContact.find(c => c.id === contact.value || c.objectID === contact.value)
    },
    availableContacts(search) {
      if (search.length > 0) {
        ContactApi.contactResolve(search)
          .then(response => {
            const contacts = response.persons.concat(response.companies)
            this.usedContacts = this.usedContacts.concat(contacts)
          })
          .catch(e => {
            console.log(e)
          })
      }
    },
    getContactObject(contact) {
      return this.globalContact.find(c => c.id === contact.value || c.objectID === contact.value)
    },
    dateToObject() {
      this.lastMaintenance = this.toObject(this.dates.lastMaintenance)
      this.nextMaintenance = this.toObject(this.dates.nextMaintenance)
      this.subscriptionStart = this.toObject(this.dates.subscriptionStart)
      this.subscriptionEnd = this.toObject(this.dates.subscriptionEnd)
    },
    getDatesFromObject: function () {
      this.dates.lastMaintenance = this.objectToIsoDate(this.lastMaintenance)
      this.dates.nextMaintenance = this.objectToIsoDate(this.nextMaintenance)
      this.dates.subscriptionStart = this.objectToIsoDate(this.subscriptionStart)
      this.dates.subscriptionEnd = this.objectToIsoDate(this.subscriptionEnd)
    },
    handleCollapseShow() {
      // Lazy-load heavy operations only when collapse is opened
      if (!this.initialized) {
        this.initialized = true
        // Load contacts asynchronously
        const contactsToLoad = this.device.maintenance.contact && this.device.maintenance.contact.userReference !== null ? [this.device.maintenance.contact.userReference] : []
        if (contactsToLoad.length > 0) {
          setTimeout(() => {
            this.availableContacts([...new Set(contactsToLoad.filter(x => x !== null && x !== ''))])
          }, 0)
        }
      }
    },
    isInvalid() {
      let valid = false
      const errorArray = []
      this.$v.$touch()
      if (this.$v.$invalid) {
        if (this.$v.lastMaintenance.$dirty && this.$v.lastMaintenance.$error) {
          errorArray.push(this.$t('message.savingErrors.lastMaintenanceDevice'))
          valid = true
        }
        if (this.$v.subscriptionStart.$dirty && this.$v.subscriptionStart.$error) {
          errorArray.push(this.$t('message.savingErrors.subscription'))
          valid = true
        }
        if (valid) {
          return [
            true,
            errorArray]
        }
      }
      return [
        this.$refs['device-maintenance-costs'].isInvalid() && this.$v.$invalid,
        errorArray
      ]
    }
  },
  validations: {
    lastMaintenance: {
      notInFuture
    },
    subscriptionStart: {
      lessThanEnding
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
